<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
							<div class="d-flex align-items-center">
								<i class="material-icons pointer mr-2" (click)="back()">arrow_back</i>
								<div>
									<h4 class="card-title mb-0">Customer Brand Matrix</h4>
									<p class="card-category mb-0" *ngIf="selectedCustomer">
										{{ selectedCustomer.debtorno }} &mdash; {{ selectedCustomer.name }}
									</p>
								</div>
							</div>
							<div class="d-flex align-items-center gap-2" *ngIf="selectedCustomer && brandData.length">
								<button class="btn btn-success btn-sm" (click)="exportXls()" [disabled]="exporting" matTooltip="Export XLS">
									<i class="fa fa-file-excel-o"></i>
								</button>
								<button class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="exporting" matTooltip="Export PDF">
									<i class="fa fa-file-pdf-o"></i>
								</button>
								<button mat-stroked-button (click)="showCopySection = !showCopySection">
									<mat-icon>content_copy</mat-icon> Copy From
								</button>
							</div>
						</div>
					</div>

					<div class="card-body">

						<!-- Customer Search -->
						<div class="row mb-3">
							<div class="col-md-5 col-sm-8 col-12">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Customer</mat-label>
									<mat-icon matPrefix>search</mat-icon>
									<input matInput [formControl]="customerControl" (input)="customerSearch($event.target.value)" [matAutocomplete]="autoCustomer" placeholder="Name or account #...">
									<mat-autocomplete #autoCustomer="matAutocomplete" [displayWith]="displayCustomerFn" (optionSelected)="onCustomerSelected($event.option.value)">
										<mat-option *ngFor="let opt of searchResults" [value]="opt">
											<b>{{ opt.debtorno }}</b> &mdash; {{ opt.name }}
										</mat-option>
									</mat-autocomplete>
									<mat-spinner matSuffix [diameter]="18" *ngIf="sending"></mat-spinner>
								</mat-form-field>
							</div>
						</div>

						<!-- Copy from panel -->
						<div class="copy-panel mb-3" *ngIf="showCopySection && selectedCustomer">
							<div class="d-flex align-items-center flex-wrap gap-2">
								<mat-icon class="text-muted">content_copy</mat-icon>
								<strong>Copy brand matrix from another customer</strong>
								<mat-form-field appearance="outline" class="mb-0 copy-field">
									<mat-label>Source customer</mat-label>
									<input matInput [formControl]="copyFromControl" (input)="copyFromSearch($event.target.value)" [matAutocomplete]="autoCopyFrom" placeholder="Search...">
									<mat-autocomplete #autoCopyFrom="matAutocomplete" [displayWith]="displayCustomerFn" (optionSelected)="onCopyFromSelected($event.option.value)">
										<mat-option *ngFor="let opt of copyFromResults" [value]="opt">
											<b>{{ opt.debtorno }}</b> &mdash; {{ opt.name }}
										</mat-option>
									</mat-autocomplete>
								</mat-form-field>
								<button mat-raised-button color="accent" [disabled]="!copyFromCustomer" (click)="runCopyBrands()">
									Copy to {{ selectedCustomer.debtorno }}
								</button>
								<button mat-icon-button (click)="showCopySection = false"><mat-icon>close</mat-icon></button>
							</div>
						</div>

						<!-- No customer -->
						<div *ngIf="!selectedCustomer" class="empty-state">
							<mat-icon>label</mat-icon>
							<p>Search for a customer above to manage their brand discounts.</p>
						</div>

						<ng-container *ngIf="selectedCustomer">

							<!-- Controls row -->
							<div class="controls-row mb-3">
								<div class="d-flex align-items-center flex-wrap gap-2">
									<mat-form-field appearance="outline" class="mb-0 filter-field">
										<mat-label>Filter brands</mat-label>
										<mat-icon matPrefix>search</mat-icon>
										<input matInput [(ngModel)]="cardFilter" placeholder="Brand name...">
										<button matSuffix mat-icon-button *ngIf="cardFilter" (click)="cardFilter = ''"><mat-icon>clear</mat-icon></button>
									</mat-form-field>
									<span class="count-badge">{{ filteredBrandData().length }} / {{ brandData.length }}</span>
								</div>
								<div class="d-flex align-items-center flex-wrap gap-2">
									<mat-form-field appearance="outline" class="mb-0 bulk-field">
										<mat-label>Set all to %</mat-label>
										<input matInput type="number" [(ngModel)]="bulkDiscountPercent" placeholder="e.g. 15">
										<span matSuffix>%</span>
									</mat-form-field>
									<button mat-raised-button color="primary" [disabled]="!brandData.length || bulkDiscountPercent === ''" (click)="applyBulkDiscount()">
										<mat-icon>tune</mat-icon> Apply All
									</button>
									<button mat-raised-button color="accent" (click)="showAddPanel = !showAddPanel">
										<mat-icon>{{ showAddPanel ? 'close' : 'add' }}</mat-icon> {{ showAddPanel ? 'Cancel' : 'Add Brand' }}
									</button>
								</div>
							</div>

							<!-- Add brand panel -->
							<div class="add-panel mb-3" *ngIf="showAddPanel">
								<div class="d-flex align-items-center flex-wrap gap-2">
									<mat-icon class="text-success">add_circle</mat-icon>
									<strong>Add brand discount</strong>
									<mat-form-field appearance="outline" class="mb-0 add-brand-field">
										<mat-label>Brand</mat-label>
										<mat-select [(ngModel)]="addBrandId">
											<mat-option value="">— select brand —</mat-option>
											<mat-option *ngFor="let b of brandsNotInMatrix()" [value]="b.manufacturer_id">
												{{ b.name || b.brand_name || b.manufacturer_id }}
											</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field appearance="outline" class="mb-0 add-disc-field">
										<mat-label>Discount %</mat-label>
										<input matInput type="number" [(ngModel)]="addDiscountPercent" placeholder="0">
										<span matSuffix>%</span>
									</mat-form-field>
									<button mat-raised-button color="primary" [disabled]="!addBrandId" (click)="addBrand()">
										<mat-icon>save</mat-icon> Save
									</button>
								</div>
							</div>

							<!-- Loading -->
							<div *ngIf="loading" class="text-center py-4">
								<mat-spinner [diameter]="36" class="mx-auto"></mat-spinner>
							</div>

							<!-- Brand cards -->
							<div *ngIf="!loading">
								<div class="brand-grid" #exportTable>
									<ng-container *ngFor="let row of filteredBrandData(); trackBy: trackByBrand">
										<div class="brand-card" [ngClass]="getCardClass(row.discount)">
											<div class="brand-card-header">
												<span class="brand-name" [title]="row.brand_name || row.brand">{{ row.brand_name || row.brand }}</span>
												<span class="brand-id">#{{ row.brand }}</span>
											</div>
											<div class="brand-discount-badge" [ngClass]="getCardClass(row.discount)">
												{{ row.editValue | number:'1.0-2' }}%
											</div>
											<div class="brand-card-edit">
												<div class="input-group input-group-sm">
													<input type="number" class="form-control"
														[(ngModel)]="row.editValue"
														(keydown.enter)="saveBrand(row)"
														placeholder="0">
													<div class="input-group-append">
														<button class="btn btn-primary btn-sm" (click)="saveBrand(row)" matTooltip="Save">
															<mat-icon class="small-icon">save</mat-icon>
														</button>
													</div>
												</div>
											</div>
											<div class="brand-card-footer">
												<button mat-icon-button color="warn" (click)="removeBrand(row)" matTooltip="Remove">
													<mat-icon class="small-icon">delete_outline</mat-icon>
												</button>
											</div>
										</div>
									</ng-container>
								</div>

								<!-- Empty state -->
								<div class="empty-state" *ngIf="!filteredBrandData().length">
									<mat-icon>label_off</mat-icon>
									<p>No brand discounts{{ cardFilter ? ' matching "' + cardFilter + '"' : '' }}.</p>
									<button mat-raised-button color="accent" (click)="showAddPanel = true" *ngIf="!cardFilter">
										<mat-icon>add</mat-icon> Add first brand
									</button>
								</div>
							</div>

						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
